<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img src="./../assets/img/logo.svg" alt="logo" />
          <span class="desc">GETCRUSHSKIN</span>
        </router-link>
      </div>

      <div class="right">
        <ul class="nav">
          <li class="nav__item" @click="sellSkin">
            <a class="nav-link desc">
              {{ $t("Sell skin") }}
            </a>
          </li>
          <li class="nav__item">
            <router-link
              class="nav-link desc"
              :to="{ name: 'ProductListPage', params: { itemType: 'all' } }"
              >{{ $t("Market") }}</router-link
            >
          </li>
        </ul>
        <div
          class="select-container language-select-container"
          v-if="currencyOptions && currencyOptions.length > 1"
        >
          <SelectComponent
            v-model="selectedCurrency"
            :options="currencyOptions"
            @select="handleCurrencyChange"
            class="select2 single language-select"
          />
        </div>
        <div
          v-if="languages && languages.length > 1"
          class="select-container language-select-container"
        >
          <SelectComponent
            v-model="selectedLanguage"
            :options="languageOptions"
            @select="handleLanguageChange"
            class="select2 single language-select"
          />
        </div>
        <div v-if="isAuth" class="user-menu">
          <!-- Cart Button with Dropdown -->

          <div class="wallet-button">
            <div class="img-wrapper">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.6">
                  <path
                    d="M17 14H17.01"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </div>
            <div class="balance-box">
              <span class="desc text-white">
                <b
                  >{{ userBalance }}
                  <span class="text-red">{{ currencySymbol }}</span></b
                >
              </span>
            </div>
          </div>

          <VDropdown
            :distance="21"
            placement="bottom"
            :triggers="['click']"
            :autoHide="true"
            ref="cartDropdown"
            @apply-show="openCartDropdown"
            @apply-hide="closeCartDropdown"
          >
            <button class="cart-button">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_36_361)">
                  <path
                    d="M2 0C1.73478 0 1.48043 0.10536 1.29289 0.29289C1.10536 0.48043 1 0.73478 1 1C1 1.26522 1.10536 1.51957 1.29289 1.70711C1.48043 1.89464 1.73478 2 2 2H3.22L3.525 3.222C3.52803 3.23607 3.53136 3.25007 3.535 3.264L4.893 8.694L4 9.586C2.74 10.846 3.632 13 5.414 13H14C14.2652 13 14.5196 12.8946 14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12C15 11.7348 14.8946 11.4804 14.7071 11.2929C14.5196 11.1054 14.2652 11 14 11H5.414L6.414 10H13C13.1857 9.9999 13.3676 9.9481 13.5255 9.8504C13.6834 9.7528 13.811 9.6131 13.894 9.447L16.894 3.447C16.9702 3.29458 17.0061 3.12522 16.9985 2.95501C16.9908 2.78479 16.9398 2.61935 16.8502 2.47439C16.7606 2.32944 16.6355 2.20977 16.4867 2.12674C16.3379 2.04372 16.1704 2.00009 16 2H5.28L4.97 0.757C4.91583 0.54075 4.79095 0.34881 4.61521 0.21166C4.43946 0.0745 4.22293 1e-05 4 0H2ZM15 15.5C15 15.8978 14.842 16.2794 14.5607 16.5607C14.2794 16.842 13.8978 17 13.5 17C13.1022 17 12.7206 16.842 12.4393 16.5607C12.158 16.2794 12 15.8978 12 15.5C12 15.1022 12.158 14.7206 12.4393 14.4393C12.7206 14.158 13.1022 14 13.5 14C13.8978 14 14.2794 14.158 14.5607 14.4393C14.842 14.7206 15 15.1022 15 15.5ZM5.5 17C5.89782 17 6.27936 16.842 6.56066 16.5607C6.84196 16.2794 7 15.8978 7 15.5C7 15.1022 6.84196 14.7206 6.56066 14.4393C6.27936 14.158 5.89782 14 5.5 14C5.10218 14 4.72064 14.158 4.43934 14.4393C4.15804 14.7206 4 15.1022 4 15.5C4 15.8978 4.15804 16.2794 4.43934 16.5607C4.72064 16.842 5.10218 17 5.5 17Z"
                    fill="#9D1616"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_36_361">
                    <rect width="18" height="18" fill="#9D1616" />
                  </clipPath>
                </defs>
              </svg>

              <div v-if="cartContents.length" class="cart-indicator">
                {{ cartContents.length }}
              </div>
            </button>

            <!-- Dropdown content -->
            <template #popper="{}">
              <CartDropdown
                :cartContents="cartContents"
                :userBalance="walletBalance"
                @close="handleCloseCartDropdown"
                @remove-item="removeItemFromCart"
                @openCartCheckout="openCartCheckout"
              />
            </template>
          </VDropdown>

          <router-link to="/profile/details" class="profile-button">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 0C6.383 0 4.25391 2.1291 4.25391 4.74609C4.25391 7.36309 6.383 9.49219 9 9.49219C11.617 9.49219 13.7461 7.36309 13.7461 4.74609C13.7461 2.1291 11.617 0 9 0Z"
                fill="#9D1616"
              />
              <path
                d="M14.9051 12.5928C13.6057 11.2734 11.8831 10.5469 10.0547 10.5469H7.94531C6.11691 10.5469 4.39432 11.2734 3.09495 12.5928C1.80193 13.9057 1.08984 15.6387 1.08984 17.4727C1.08984 17.7639 1.32595 18 1.61719 18H16.3828C16.674 18 16.9102 17.7639 16.9102 17.4727C16.9102 15.6387 16.1981 13.9057 14.9051 12.5928Z"
                fill="#9D1616"
              />
            </svg>
          </router-link>
        </div>

        <template v-if="!isAuth">
          <button class="button w-130" @click="openSignUp">
            {{ $t("Sign up") }}
          </button>
          <button class="button red w-130" @click="openSignIn">
            {{ $t("Login") }}
          </button>
        </template>
      </div>
    </div>

    <!-- MegaMenu Component -->
    <MegaMenu
      v-if="showDropdown"
      :categories="categories"
      :additionalCategories="additionalCategories"
      @mouseenter="showDropdown = true"
      @mouseleave="hideDropdown"
    />
  </header>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import MegaMenu from "./MegaMenu.vue";
import CartDropdown from "./CartDropdown.vue";
import { debounce } from "lodash";
import { onClickOutside } from "@vueuse/core";

export default {
  name: "HeaderComponent",
  components: {
    MegaMenu,
    CartDropdown,
  },
  props: {
    isAuth: { type: Boolean, required: true },
    cartContents: { type: Array, required: true },
  },
  data() {
    return {
      showDropdown: false,
      showCartDropdown: false,
      searchTerm: "",
      searchResults: [],
      showSearchResults: false,
      searchIsLoading: false,
      selectedLanguage: null,
      selectedCurrency: null,
      categories: [],
      additionalCategories: [
        { name: "sale", link: "/products/all?sale=true" },
        // { name: 'CONTAINERS', link: '/products/containers' },
        // { name: 'GRAFFITI', link: '/products/graffiti' },
        // { name: 'COLLECTIBLES', link: '/products/collectibles' },
        // { name: 'STICKERS', link: '/products/stickers' },
        // { name: 'PASSES', link: '/products/passes' },
        // { name: 'MUSIC KITS', link: '/products/music-kits' },
        // { name: 'AGENTS', link: '/products/agents' },
        // { name: 'OTHER', link: '/products/other' }
      ],
    };
  },
  computed: {
    ...mapState("app", [
      "languages",
      "currencies",
      "currentLanguage",
      "currency",
    ]),
    ...mapGetters("app", ["currencySymbol"]),
    ...mapGetters("user", ["userBalance"]),
    languageOptions() {
      if (!this.languages) return [];
      return this.languages.map((lang) => ({ id: lang.id, text: lang.title }));
    },
    currencyOptions() {
      return this.currencies.map(({ code }) => ({ id: code, text: code }));
    },
  },
  created() {
    this.debouncedSearchItems = debounce(this.searchItems, 300);
    this.fetchSubcategories();
  },
  watch: {
    currentLanguage(newLang) {
      this.selectedLanguage = newLang;
    },
    searchTerm(newVal) {
      if (!this.$route.query.search || newVal !== this.$route.query.search) {
        this.debouncedSearchItems();
      }
    },
    $route(to) {
      if (
        (to.name === "ProductListPage" && !to.query.search) ||
        to.name !== "ProductListPage"
      ) {
        this.searchTerm = "";
        this.searchResults = [];
      } else if (to.name === "ProductListPage" && to.query.search) {
        this.searchTerm = to.query.search;
      }
      this.showSearchResults = false; // Hide results on route change
      this.showDropdown = false;
    },
  },
  mounted() {
    this.selectedLanguage = this.currentLanguage;

    if (this.currency) {
      this.selectedCurrency = this.currency.code;
    }

    if (this.$route.name === "ProductListPage" && this.$route.query.search) {
      this.searchTerm = this.$route.query.search;
    }
    onClickOutside(this.$refs.dropdownRef, () => {
      this.isOpen = false;
    });

    onClickOutside(this.$refs.searchContainer, () => {
      this.showSearchResults = false;
    });
  },
  methods: {
    openCartCheckout() {
      this.$emit("openCartCheckout");
      this.$refs.cartDropdown.hide();
    },
    sellSkin() {
      if (this.isAuth) {
        this.$emit("openSellSkinModal");
      } else {
        this.$emit("openSignIn");
      }
    },
    ...mapActions("modals", ["openDepositModal"]),
    ...mapActions("app", ["changeLocale", "changeCurrency"]),
    ...mapActions("modals", ["openCartDropdown", "closeCartDropdown"]),
    ...mapActions("user", ["fetchUserData"]),
    ...mapActions("cart", ["fetchCartItems"]),
    handleLanguageChange(option) {
      const selectedLang = this.languages.find(
        (lang) => lang.title === option.text,
      );
      if (selectedLang) {
        this.changeLocale(selectedLang.id);
      }
    },
    handleCurrencyChange(option) {
      this.changeCurrency(option.text);
    },
    handleEnterKey() {
      if (this?.searchResults?.length > 0) {
        this.$router.push({
          name: "ProductListPage",
          params: { itemType: "all" },
          query: { search: this.searchTerm },
        });
      }
    },
    fetchSubcategories() {
      this.$http
        .get(`${process.env.VUE_APP_API}items/subcategories`)
        .then((response) => {
          this.categories = response.data.payload;
        })
        .catch((error) => {
          console.error("Error fetching subcategories:", error);
        });
    },
    handleCloseCartDropdown() {
      this.closeCartDropdown();
      if (this.$refs.cartDropdown) {
        this.$refs.cartDropdown.hide();
      }
    },
    searchItems() {
      if (this.searchTerm.length > 2) {
        this.searchIsLoading = true;
        this.$http
          .get(`${process.env.VUE_APP_API}items/list`, {
            params: { search: this.searchTerm },
          })
          .then((response) => {
            this.searchResults = response.data.payload;
            this.showSearchResults = true;
          })
          .catch((error) => {
            console.error("Error searching items:", error);
            this.searchResults = [];
            this.showSearchResults = false;
          })
          .finally(() => {
            this.searchIsLoading = false;
          });
      } else {
        this.searchResults = [];
        this.showSearchResults = false;
      }
    },
    removeItemFromCart(item) {
      this.$emit("removeOneFromCart", item);
    },
    toggleCartDropdown() {
      this.showCartDropdown = !this.showCartDropdown;
    },
    openSignIn() {
      this.$emit("openSignIn");
    },
    openSignUp() {
      this.$emit("openSignUp");
    },
    hideDropdown() {
      setTimeout(() => {
        if (!this.$el.querySelector(".mega-menu:hover")) {
          this.showDropdown = false;
        }
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  padding: 32px 16px 0;
  position: relative;
}
.header {
  border: 0;
}

.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  height: 100%;
  max-width: 1420px;
  margin: 0 auto;
}

.left,
.right {
  display: flex;
  align-items: center;
}
.right {
  gap: 18px;
  flex: 1;
  justify-content: flex-end;
}

.logo {
  gap: 10px;
  display: flex;
  align-items: center;
}
.logo img {
  display: block;
  width: 36px;
}
.logo .desc {
  font-weight: 700;
}

.nav {
  display: flex;
  gap: 18px;
  align-items: center;
}

.nav__item {
  position: relative;
  box-sizing: border-box;
}

.nav-link {
  color: #ffffff;
  display: block;
  font-weight: 700;
}

.nav__item-search {
  margin-right: 28px;
  position: relative;
  max-width: 292px;
  flex: 1;
}
.search-bar {
  display: flex;
  align-items: center;

  input {
    padding-left: 44px;
  }
  .search-icon {
    position: absolute;
    width: 16px;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.user-menu {
  display: flex;
  align-items: center;
}

.corner-background {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url("./../assets/img/yellow-corners.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}

.corner-background {
  padding: 3px;
  border-radius: 3px;
}

.cart-button-frame,
.wallet-button-frame,
.profile-button-frame {
  position: relative;
  padding: 3px;
  cursor: pointer;
}

.cart-button-frame:hover,
.wallet-button-frame:hover,
.profile-button-frame:hover {
  border-color: #15ca5c;
}

/* Cart Button */
.cart-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  width: 46px;
  height: 46px;
  padding: 11px;
  position: relative;
}

.cart-button img {
  width: 20px;
  height: 20px;
}

.cart-indicator {
  position: absolute;
  right: 5px;
  bottom: 11px;
  width: 5px;
  height: 5px;
  background-color: #6ec226;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0;
  font-weight: 700;
  color: #151522;
}

/* Wallet Balance Button */
.wallet-button {
  display: flex;
  align-items: center;
  padding: 0;
  pointer-events: none;
  display: none;
}

.wallet-button .img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wallet-button img {
  width: 18px;
  height: 18px;
}

.balance-box {
  flex: 1;
  font-family: "Roboto", sans-serif;
  padding: 10px;
  text-align: left;
  text-wrap: nowrap;
}

/* Profile Button */
.profile-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
  padding: 11px;
}

.profile-button img {
  width: 20px;
  height: 20px;
}

.dropdown-container {
  position: relative;
}

.cart-dropdown-container {
  position: relative;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
}

.arrow-up {
  transform: rotate(180deg);
}

@media (max-width: 1440px) {
  .header {
    width: 100%;
  }
}

@media screen and (max-width: 1200px) {
  .nav__item-search {
    display: none;
  }
}
@media (max-width: 768px) {
  .header {
    padding: 12px 16px;
    .wrapper {
      gap: 20px;
      justify-content: flex-start;
    }
  }

  .left {
    gap: 20px;
  }

  .wallet-button-frame,
  .profile-button-frame {
    display: none;
  }

  .login-button-frame,
  .nav__item-search {
    display: none;
  }
  .nav {
    display: none;
  }
  .right {
    display: none;
  }
}

@media (max-width: 480px) {
  .nav__item-categories {
    display: none;
  }

  .nav {
    gap: 21px;
  }
}
</style>
